<template>
  <el-table :data="propsData[type].tableData"
    class="egl-table list-table" @sort-change="val => $emit('sort', val)" @filter-change="val => $emit('filter', val)">
    <el-table-column :prop="item.prop" :label="item.label" align="center" v-for="(item, idx) in propsData[type].thead" :key="idx"
      :min-width="item.width" :formatter="item.formatter" :sortable="item.sort" :filters="item.filters"
      :filter-value="item.filteredValue" :column-key="item.columnKey" />
    <template v-if="type === 'coupon'">
      <el-table-column  label="操作" align="center" width="231">
        <template slot-scope="scope">
          <div class="handle">
            <a @click="$router.push(`/coupon-list?couponId=${scope.row.couponId}`)">優待券詳細</a>
            <template v-if="scope.row.memberCouponStatus === 'normal'">
              <el-divider direction="vertical"></el-divider>
              <a @click="$emit('updateStatus',scope.row.id, 'expired')">無効</a>
              <el-divider direction="vertical"></el-divider>
              <a @click="$emit('updateStatus',scope.row.id, 'used')">使用</a>
            </template>
          </div>
        </template>
      </el-table-column>
    </template>
    <template v-if="!isDetailDisabled && (type === 'coupon' || type === 'point')">
      <el-table-column align="center">
        <template slot="header">
          <a @click="type === 'coupon' ? $emit('openCoupon') : $emit('openAdjustPoint')"
          style="color: rgb(249, 183, 73); letter-spacing: 0.72px;">{{
            type === 'coupon' ? '優待券付与' : 'ポイント数調整'
          }}</a>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>
<script>
export default {
  props: {
    propsData: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: "coupon"
    },
    isDetailDisabled: {
      type: Boolean,
      default: false,
    }
  },
};
</script>